<ng-container *transloco="let t; read: 'layout.navigation'">
  @if (item.children && item.children.length > 0) {
    <a  mat-list-item
        [ngClass]="{'expanded': expanded}"
        class="nav-item"
        (click)="expanded = !expanded"
        tabindex="0"
        (keyup.space)="expanded = !expanded"
        (keyup.enter)="expanded = !expanded"
    >
      <mat-icon matListIcon>{{item.icon}}</mat-icon>
      <span>{{ t(item.label) }}</span>
      <mat-icon class="keyboard-icon">keyboard_arrow_right</mat-icon>
    </a>
    @if (expanded && item.children.length) {
      <div @smoothHideAndShow class="child-container">
        @for (child of item.children; track $index) {
          <div><menu-list-item class="child" [item]="child" [isChild]="true" *ngIf="child.onMenu"></menu-list-item></div>
        }
      </div>
    }
  } @else {
    <a  mat-list-item
        [ngClass]="{'expanded': expanded}"
        class="nav-item"
        [routerLink]="[item.route]"
        tabindex="0">
      <mat-icon matListIcon>{{item.icon}}</mat-icon>
      <span>{{ t(item.label) }}</span>
      <!-- <mat-icon class="keyboard-icon">keyboard_arrow_right</mat-icon> -->
    </a>
  }
</ng-container>
